export default __webpack_public_path__ + "static/media/first_page.3af1f219.svg";